import { i18n } from '@/services/i18n'

export default {
  type: 'W',
  render: (value) => i18n.t(value ? 'bool.yes' : 'bool.no'),
  compare: (a, b) => (a && b ? 0 : a && !b ? 1 : -1)
}
